import { HttpRequest, HttpEvent, HttpHandlerFn } from "@angular/common/http";
import { Observable } from "rxjs";

export function languageInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const requestWithAuthorization = req.clone({
        headers: req.headers.set('language_code', 'es'),
    });
    return next(requestWithAuthorization);
}